import React, { useState, useEffect } from 'react';

export const CookieBanner = ({ t }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 p-6 shadow-lg">
      <div className="container mx-auto flex flex-col md:flex-row items-center justify-between gap-4 max-w-6xl">
        <p className="text-sm text-gray-600 flex-1 font-light">
          {t.cookie.message}
        </p>
        <div className="flex items-center gap-4">
          <button
            onClick={handleDecline}
            className="text-gray-600 hover:text-gray-900 px-6 py-2 text-sm transition-colors"
          >
            {t.cookie.decline}
          </button>
          <button
            onClick={handleAccept}
            className="border border-gray-300 hover:border-gray-900 text-gray-900 px-6 py-2 text-sm transition-colors"
          >
            {t.cookie.accept}
          </button>
        </div>
      </div>
    </div>
  );
};
